import React from 'react';
import { createRoot } from 'react-dom/client';
import '../../scss/chatbot.scss';
import ChatBot from './components/ChatBot';

const resolveReactRoot = () => {
  return document.querySelector('#react-root');
};

const Stage4euReactApp = () => {
  return <ChatBot />; 
};

const bootstrapReact = () => {
  const rootElement = resolveReactRoot();

  if (!rootElement) {
    return;
  }

  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <Stage4euReactApp />
    </React.StrictMode>
  );
};

bootstrapReact();
